function checkIsSurvey(channel, currentMessage, pathname) {
  return (
    channel === 'ON_SITE' &&
    (currentMessage?.variationType === 'SURVEY' || pathname.includes('survey'))
  );
}

export { checkIsSurvey };
